window.addEventListener('load', () => {

  let currentWindowHeight   = window.innerHeight
  let renderSync            = false
  let stopTrigger           = (window.innerHeight)* -1

  const step01 = document.getElementById('education-step01')
  const step04 = document.getElementById('education-step04')
  const step06 = document.getElementById('education-step06')

  let sectStep01  = step01.getBoundingClientRect().top

  // EDUCATION SCROLL EVENTS
  let scrollEvent = () => {

    if (!renderSync) {
      requestAnimationFrame(function () {
        renderSync = false
        let offsetYStep01   = step01.getBoundingClientRect().top + (currentWindowHeight / 2)
        let offsetYStep04   = step04.getBoundingClientRect().top + (currentWindowHeight / 2)
        let offsetYStep06   = step06.getBoundingClientRect().top + (currentWindowHeight / 2)

        if (offsetYStep01 >= 0) {
          document.getElementsByClassName('position-key q')[0].style.transform = "translate3d(0," + (-20 +(offsetYStep01 / 24)) + "%, 0)"
          document.getElementsByClassName('position-key w')[0].style.transform = "translate3d(0," + (-20 -(offsetYStep01 / 36)) + "%, 0)"
          document.getElementsByClassName('position-key e')[0].style.transform = "translate3d(0," + (-20 +(offsetYStep01 / 24)) + "%, 0)"
          document.getElementsByClassName('position-key t')[0].style.transform = "translate3d(0," + (20 -(offsetYStep01 / 36)) + "%, 0)"
          document.getElementsByClassName('position-key y')[0].style.transform = "translate3d(0," + (-20 +(offsetYStep01 / 24)) + "%, 0)"
          document.getElementsByClassName('position-key enter')[0].style.transform = "translate3d(0," + (-20 -(offsetYStep01 / 36)) + "%, 0)"
        }

        // if (offsetYStep04 <= 0) {
        //   console.log('done');
        // }
        if (offsetYStep04 - (currentWindowHeight*1.5) <= 0 && offsetYStep04 >= 0) {
          document.getElementsByClassName('position block01')[0].style.transform  = "translate3d(0," + (-20 +(offsetYStep04 / 48)) + "%, 0)"
          document.getElementsByClassName('position block02')[0].style.transform  = "translate3d(0," + (30 -(offsetYStep04 / 48)) + "%, 0)"
          document.getElementsByClassName('position dice01')[0].style.transform  = "translate3d(0," + (-20 +(offsetYStep04 / 24)) + "%, 0)"
          document.getElementsByClassName('position dice02')[0].style.transform  = "translate3d(0," + (20 -(offsetYStep04 / 14)) + "%, 0)"
          document.getElementsByClassName('position clock')[0].style.transform  = "translate3d(0," + (30 -(offsetYStep04 / 24)) + "%, 0)"
        }

        if (offsetYStep06 - (currentWindowHeight) <= 0) {
          step06.classList.add('active')
        }
      })
    }
  }

  document.addEventListener('scroll', scrollEvent, {passive: true})
  // END EDUCATION SCROLL EVENTS

}) //onload
